import PropTypes from "prop-types"
import React, { useState } from "react"
import { useForm } from "react-hook-form"
import { useMarina } from "src/contexts/MarinaContext"

import Button from "src/components/Button"
import Form from "src/components/Form"
import Modal from "src/components/Modal"

const Beam = ({ modifier, onClose, mergeModifierData }) => {
  const { marinaSlug, currencySymbol } = useMarina()

  const { register, setValue, getValues, handleSubmit } = useForm({
    defaultValues: {
      modifier,
    },
  })

  const intialUnits = modifier.fixedAmount ? "fixed" : "percentage"
  const [units, setUnits] = useState(intialUnits)

  const onUnitChange = (event) => {
    setUnits(event)
    setValue("modifier.fixedAmount", null)
    setValue("modifier.percentageAmount", null)
  }

  const onSaveButtonClick = (data) => {
    mergeModifierData(data)
    onClose()
  }

  const onDeleteButtonClick = () => {
    setValue("modifier.fixedAmount", null)
    setValue("modifier.percentageAmount", null)
    mergeModifierData(getValues())
    onClose()
  }

  return (
    <>
      <Modal.Body>
        <div className="w-2/3">
          <Form.Label htmlFor="beam">Beam</Form.Label>
          <div className="flex flex-row gap-x-4">
            <div className="w-2/3">
              <Form.Select
                onChange={(event) => onUnitChange(event.target.value)}
              >
                <option
                  key="fixed"
                  id="fixed-amount"
                  selected={units === "fixed"}
                  value="fixed"
                >
                  Fixed Charge
                </option>
                <option
                  key="percentage"
                  id="percentage-amount"
                  value="percentage"
                  selected={units === "percentage"}
                >
                  Percentage Based Charge
                </option>
              </Form.Select>
            </div>
            <div className="w-1/3">
              <Form.IconTextField
                icon={<span>{units === "fixed" ? currencySymbol : "%"}</span>}
                position={units === "fixed" ? "left" : "right"}
                id="beam"
                {...register(
                  `modifier.${
                    units === "fixed" ? "fixedAmount" : "percentageAmount"
                  }`
                )}
              />
            </div>
          </div>
          <hr className="my-4" />
          {units === "fixed" && (
            <>
              <p>
                <strong>Description:</strong> Any vessel with a beam greater
                than the configured beam (
                <a
                  href={`/manage/${marinaSlug}/settings/public_profile`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {"Settings > Public Profile"}
                </a>
                ) will have the fixed charge added on top of the base rate.
              </p>
              <p>
                <strong>Example:</strong> If there is a daily rate of{" "}
                {currencySymbol}5 and a {currencySymbol}10 fixed charge beam
                modifier in place, a vessel with a beam greater than the
                configured beam will be charged {currencySymbol}15 per day.
              </p>
            </>
          )}
          {units === "percentage" && (
            <>
              <p>
                <strong>Description:</strong> Any vessel with a beam greater
                than the configured beam (
                <a
                  href={`/manage/${marinaSlug}/settings/public_profile`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {"Settings > Public Profile"}
                </a>
                ) will be given the percentage charge added on top of the base
                rate.
              </p>
              <p>
                <strong>Example:</strong> If there is a daily rate of{" "}
                {currencySymbol}5 and a 100% percentage charge of beam modifier
                in place, a vessel with a beam greater than the configured beam
                will be charged {currencySymbol}10 per day.
              </p>
            </>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="mt-5 flex justify-between">
          <Button variant="tertiary" onClick={onDeleteButtonClick}>
            Delete
          </Button>
          <div className="flex justify-end space-x-2">
            <Button variant="secondary" onClick={onClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSubmit(onSaveButtonClick)}>
              Save Changes
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  )
}

Beam.propTypes = {
  modifier: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  mergeModifierData: PropTypes.func.isRequired,
}

export default Beam
